var integerValidator = require('./integerValidator');
var nonNegativeNumberValidator = require('./nonNegativeNumberValidator');
var booleanValidate = require('shared').booleanValidate;

var validator = booleanValidate.and(integerValidator, nonNegativeNumberValidator);
validator.message = 'Expected a positive integer';
module.exports = validator;
